<template>
  <b-modal
    id="modal-status-filter"
    ref="modal"
    v-model="open"
    hide-footer
    no-close-on-backdrop
    size="lg"
    title="Statuses"
    class="p-4"
  >
    <div class="d-flex flex-wrap justify-content-start">
      <b-badge
        v-for="status in statuses"
        :key="status.key"
        class="m-50"
        :style="{
          backgroundColor: getLightBackground(status.color),
          color: status.color,
          fontSize: '0.85rem',
          padding: '0.5rem 0.8rem'
        }"
      >
        {{ status.name.toUpperCase() }}
      </b-badge>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BBadge } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BBadge,
  },
  props: {
    statuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    openModal() {
      this.open = true
    },
    getLightBackground(color) {
      if (!color) return 'rgba(100, 100, 100, 0.1)'
      // Check if it's hex and convert or just manipulate rgba string
      if (color.startsWith('#')) {
        return `${color}1F` // Adds ~12% opacity in hex
      }
      return color.replace('rgb', 'rgba').replace(')', ', 0.12)')
    },
  },
}
</script>
